module.exports = __webpack_public_path__ + "img/18X.9ec9f182.png";